import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'clsx';
import { styled, css } from 'styled-components';
import { NavLink } from '@/js/libs/router';
import { Media } from '../../theme/Media.js';
const LINK_CLASS_NAME = 'nav-item-link';
const ACTIVE_CLASS_NAME = 'active';
const activeLinkStyles = css `
  &,
  &:visited,
  &:active,
  &:focus,
  &:hover {
    color: ${({ theme }) => theme.colors.main};
  }

  &::after {
    content: '';
    display: block;
    width: 30px;
    height: 2px;
    background: ${({ theme }) => theme.colors.main};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
`;
const linkStyles = css `
  display: inline-flex;
  padding: 0 10px;
  min-width: 60px;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
  font-size: 13px;
  white-space: nowrap;

  @media ${Media.xsMax} {
    min-height: 40px;
  }

  &,
  &:visited,
  &:active,
  &:focus,
  &:hover {
    color: ${({ theme }) => theme.colors.grey100_1};
  }

  &.${ACTIVE_CLASS_NAME} {
    ${activeLinkStyles}
  }
`;
const Item = styled.li `
  height: 100%;
  display: inline-flex;

  .${LINK_CLASS_NAME} {
    ${linkStyles}
  }
`;
/**
 * SubHeader component's navigation item.
 * @param props - props of the component
 * @param props.children - children of the component
 * @param props.dataTestId - testId data attribute
 * @param props.getOverriddenActive - callback that allows you to override activity state of the link.
 * @param props.to - the path or path object to which the link refers
 * @param props.end - allows to change the matching logic for the active state to only match to the "end" of the `to` path.
 * If the URL is longer than to, it will no longer be considered active.
 * @returns JSX.Element
 */
const NavItem = ({ dataTestId, children, getOverriddenActive, to, end, ...restProps }) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const getClassName = React.useCallback(({ isActive }) => {
        const calculatedActive = getOverriddenActive ? getOverriddenActive(isActive, to, end) : isActive;
        return classNames(LINK_CLASS_NAME, { [ACTIVE_CLASS_NAME]: calculatedActive });
    }, [end, getOverriddenActive, to]);
    return (_jsx(Item, { children: _jsx(NavLink, { ...restProps, className: getClassName, "data-testid": dataTestId, to: to, end: end, children: children }) }));
};
export default React.memo(NavItem);
